import * as React from 'react';
import { Button, type ButtonProps } from '@/shared/ui/button';
import { cn } from '@/shared/lib/cn';

export type ActionsProps = React.HTMLAttributes<HTMLDivElement>;

/** Linha de botões de ação sob uma mensagem da IA — ex. "Criar segmento"/"Salvar alterações". */
export const Actions = React.forwardRef<HTMLDivElement, ActionsProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex flex-wrap gap-2', className)} {...props} />
  ),
);
Actions.displayName = 'Actions';

export type ActionProps = ButtonProps;

export const Action = React.forwardRef<HTMLButtonElement, ActionProps>(
  ({ size = 'sm', variant = 'secondary', className, ...props }, ref) => (
    <Button ref={ref} size={size} variant={variant} className={cn(className)} {...props} />
  ),
);
Action.displayName = 'Action';
